/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { ServiceObjectMaintenanceEntryCreateV1Dto } from '../models/ServiceObjectMaintenanceEntryCreateV1Dto';
import type { ServiceObjectStatusCreateV1Dto } from '../models/ServiceObjectStatusCreateV1Dto';
import type { ServiceObjectStatusPatchV1Dto } from '../models/ServiceObjectStatusPatchV1Dto';
import type { ServiceObjectStatusV1Dto } from '../models/ServiceObjectStatusV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceObjectStatusService {
  /**
   * @param objectId the id of the serviceObject
   * @param statusId the id of the status
   * @param requestBody The maintenance entry creation payload.
   * @returns ServiceObjectStatusV1Dto create entity
   * @throws ApiError
   */
  public static serviceObjectStatusControllerV1CreateMaintenanceEntryV1(
    objectId: string,
    statusId: string,
    requestBody: ServiceObjectMaintenanceEntryCreateV1Dto,
  ): CancelablePromise<ServiceObjectStatusV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/service-objects/{objectId}/status/{statusId}/maintenance-entries',
      path: {
        objectId: objectId,
        statusId: statusId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param requestBody The status create payload.
   * @returns ServiceObjectStatusV1Dto create entity
   * @throws ApiError
   */
  public static serviceObjectStatusControllerV1CreateV1(
    objectId: string,
    requestBody: ServiceObjectStatusCreateV1Dto,
  ): CancelablePromise<ServiceObjectStatusV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/service-objects/{objectId}/status',
      path: {
        objectId: objectId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @returns ServiceObjectStatusV1Dto a entity list
   * @throws ApiError
   */
  public static serviceObjectStatusControllerV1FindAllV1(
    objectId: string,
  ): CancelablePromise<Array<ServiceObjectStatusV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-objects/{objectId}/status',
      path: {
        objectId: objectId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static serviceObjectStatusControllerV1RemoveManyV1(
    objectId: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-objects/{objectId}/status',
      path: {
        objectId: objectId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param id the id of the status
   * @returns ServiceObjectStatusV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectStatusControllerV1FindOneV1(
    objectId: string,
    id: string,
  ): CancelablePromise<ServiceObjectStatusV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-objects/{objectId}/status/{id}',
      path: {
        objectId: objectId,
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param id the id of the status
   * @param requestBody The status update payload.
   * @returns ServiceObjectStatusV1Dto the update entity
   * @throws ApiError
   */
  public static serviceObjectStatusControllerV1UpdatePartialV1(
    objectId: string,
    id: string,
    requestBody: ServiceObjectStatusPatchV1Dto,
  ): CancelablePromise<ServiceObjectStatusV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/service-objects/{objectId}/status/{id}',
      path: {
        objectId: objectId,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param id the id of the status
   * @returns ServiceObjectStatusV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectStatusControllerV1RemoveOneV1(
    objectId: string,
    id: string,
  ): CancelablePromise<ServiceObjectStatusV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-objects/{objectId}/status/{id}',
      path: {
        objectId: objectId,
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
